import { z } from 'zod';

const McpCallStatusSchema = z.enum(['success', 'error']);

const McpCallListItemSchema = z.object({
  id: z.string(),
  created_at: z.string(),
  client_name: z.string(),
  tool_name: z.string(),
  status: McpCallStatusSchema,
  execution_time_ms: z.number().nullable(),
  arguments_preview: z.string(),
  content_withheld: z.boolean(),
});

/** Shown in place of content for calls by BAA-signed users, whose content is never stored. */
export const CONTENT_WITHHELD_LABEL = 'Content withheld (BAA)';

export const McpCallListResponseSchema = z.object({
  calls: z.array(McpCallListItemSchema),
  next_cursor: z.string().nullable(),
});

export const McpCallDetailSchema = z.object({
  id: z.string(),
  created_at: z.string(),
  client_id: z.string(),
  client_name: z.string(),
  tool_name: z.string(),
  status: McpCallStatusSchema,
  execution_time_ms: z.number().nullable(),
  arguments: z.record(z.string(), z.unknown()),
  result_text: z.string(),
  error_message: z.string(),
  content_withheld: z.boolean(),
  trace_id: z.string(),
  trace_url: z.string().nullable(),
});

export const McpUsageSummarySchema = z.object({
  by_client_name: z.record(z.string(), z.number()),
  by_tool_name: z.record(z.string(), z.number()),
});

export type McpCallStatus = z.infer<typeof McpCallStatusSchema>;
export type McpCallListItem = z.infer<typeof McpCallListItemSchema>;
export type McpCallListResponse = z.infer<typeof McpCallListResponseSchema>;
export type McpCallDetail = z.infer<typeof McpCallDetailSchema>;
export type McpUsageSummary = z.infer<typeof McpUsageSummarySchema>;

export type McpCallFilters = {
  clientName: string | null;
  toolName: string | null;
  sinceHours: number;
};
